// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// Utils
import { hasChanged, now } from '../../../../utils/react/propsComparisons';

// Selectors
import { getIsCurrentVisibleBoardFetched } from '../../../../element/board/boardSelector';
import {
    currentBoardFilterCountSelector,
    elementFilterTypeSelector,
    getElementFilterQuery,
    getElementFilterSelector,
} from '../../../../element/elementFilter/elementFilterSelector';

// Components
import Icon from '../../../../components/icons/Icon';
import PillButton from '../../../../components/buttons/PillButton';

// Actions
import { clearElementFilter } from '../../../../element/elementFilter/elementFilterActions';

// Constants
import { ELEMENT_FILTER_TYPES } from '../../../../element/elementFilter/elementFilterConstants';

// Styles
import './ElementFilterUtil.scss';

const currentBoardIdChanged = hasChanged('currentBoardId');
const elementFilterChanged = hasChanged('elementFilter');
const currentBoardNowFetched = now('currentBoardFetched');

const mapStateToProps = createSelector(
    getElementFilterSelector,
    getIsCurrentVisibleBoardFetched,
    elementFilterTypeSelector,
    currentBoardFilterCountSelector,
    (elementFilter, currentBoardFetched, filterType, filterCount) => ({
        elementFilter,
        active: currentBoardFetched && elementFilter !== null,
        currentBoardFetched,
        filterCount,
        filterType,
    }),
);

const mapDispatchToProps = (dispatch) => ({
    dispatchClearElementFilter: () => dispatch(clearElementFilter()),
});

const ElementFilterSearch = ({ elementFilter }) => (
    <span className="changes">
        <span className="verb">Results for </span>
        <span className="query">‘{getElementFilterQuery(elementFilter)}’</span>
    </span>
);

ElementFilterSearch.propTypes = {
    elementFilter: PropTypes.object,
};

const ElementFilterText = ({ filterType, ...rest }) => {
    switch (filterType) {
        default:
            return <ElementFilterSearch {...rest} />;
    }
};

ElementFilterText.propTypes = {
    filterType: PropTypes.string,
};

const showUtilForElementFilterType = (filterType) => {
    switch (filterType) {
        case ELEMENT_FILTER_TYPES.SEARCH:
            return true;
        default:
            return false;
    }
};

class ElementFilterUtil extends React.Component {
    state = { utilVisible: false };

    componentWillMount() {
        this.handleFilterStateChange(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (
            currentBoardIdChanged(this.props, nextProps) ||
            elementFilterChanged(this.props, nextProps) ||
            currentBoardNowFetched(this.props, nextProps)
        ) {
            this.handleFilterStateChange(nextProps);
        }
    }

    handleFilterStateChange = (props) => {
        this.setState({ utilVisible: false });

        const { active, currentBoardFetched } = props;

        // wait util the board is fetched
        if (!active || !currentBoardFetched) return;

        this.setState({ utilVisible: true });
    };

    render() {
        const { dispatchClearElementFilter, filterType } = this.props;

        if (!showUtilForElementFilterType(filterType)) return null;

        if (!this.state.utilVisible) return null;

        return (
            <PillButton
                className={classNames('ElementFilterUtil', filterType.toLowerCase())}
                onClickFn={dispatchClearElementFilter}
            >
                <ElementFilterText {...this.props} />
                <span className="close">
                    <Icon name="close-x-small" />
                </span>
            </PillButton>
        );
    }
}

ElementFilterUtil.propTypes = {
    active: PropTypes.bool,
    currentBoardId: PropTypes.string,
    currentBoardFetched: PropTypes.bool,
    dispatchClearElementFilter: PropTypes.func,
    elementFilter: PropTypes.object,
    filterCount: PropTypes.number,
    filterType: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(ElementFilterUtil);
